import BaseClient from '@/app/model/api/response/baseApiClient'

class PlantDetailApi extends BaseClient {
  public getPlantDetail (id: string) {
    const path = '/v1/plantings/' + id
    const url = new URL(process.env.VUE_APP_API_URL + path)

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new PlantDetailApi()
